<template>
    <div>
        <Alert type="info" class="mb-3">
            {{ $t('labels.aiTranslateContentHint') }}
        </Alert>
        <div class="row">
            <div class="col-md-6">
                <FormGroup :label="$t('labels.contentSource')">
                    <AppSelect
                        @update:model-value="$emit('update:sourceLanguage', $event)"
                        :model-value="sourceLanguage?.value"
                        :selected-value="sourceLanguage?.label"
                        :options="languages"
                        optionKey="value"
                        optionValue="label"
                    />
                </FormGroup>
            </div>
            <div class="col-md-6">
                <FormGroup :label="$t('labels.targetLanguages')">
                    <AppMultiselect
                        optionKey="value"
                        optionValue="label"
                        :options="targetLanguages"
                        :model-value="selectedTargetLanguages"
                        @update:model-value="$emit('update:selectedTargetLanguages', $event)"
                    />
                </FormGroup>
            </div>
        </div>
        <FormGroup :label="$t('labels.fieldsToTranslate')">
            <div class="row">
                <div class="col-md-4 mb-2">
                    <InputGroup>
                        <AppCheckbox :model-value="allIsSelected" @update:model-value="toggleAll"/>
                        <template #append>{{ $t('labels.all') }}</template>
                    </InputGroup>
                </div>
                <div class="col-md-4 mb-2" v-for="field in fieldsForTranslation" :key="field.value">
                    <InputGroup>
                        <AppCheckbox v-model="field.selected"/>
                        <template #append>{{ field.label }}</template>
                    </InputGroup>
                </div>
            </div>
        </FormGroup>
    </div>
</template>
<script>
import Alert from '../../../../../../../components/AlertComponent.vue';
import FormGroup from '../../../../../../../components/new/form/group/FormGroup.vue';
import AppSelect from '../../../../../../../components/new/form/select/AppSelect.vue';
import AppCheckbox from '../../../../../../../components/new/form/checkbox/AppCheckbox.vue';
import InputGroup from '../../../../../../../components/new/form/InputGroup.vue';
import AppMultiselect from '../../../../../../../components/new/form/autocomplete/AppMultiselect.vue';

export default {
    name: "ContentTranslationForm",
    components: {
        Alert, FormGroup, AppSelect, AppCheckbox, InputGroup, AppMultiselect
    },
    props: {
        languagesAliases: {
            type: Array,
            default: () => []
        },
        sourceLanguage: {
            type: Object,
            default: null
        },
        targetLanguages: {
            type: Array,
            default: () => []
        },
        languages: {
            type: Array,
            default: () => []
        },
        fieldsForTranslation: {
            type: Array,
            default: () => []
        },
        selectedTargetLanguages: {
            type: Array,
            default: () => []
        }
    },
    methods: {
        toggleAll(checked) {
            this.fieldsForTranslation.forEach(field => {
                field.selected = checked;
            });
        }
    },
    computed: {
        allIsSelected() {
            return this.fieldsForTranslation.every(field => field.selected);
        }
    }
}
</script>
